import React from 'react'
import styled from '@emotion/styled'
import { spacing, Text } from '@retailer-platform/shared-components'
import {
  AttributeManagementNextStepTypeEnum,
  type PipelineStep,
} from '../../../../../../types/attributeManagement.types'
import FieldMatchPane from './FieldMatchPane'
import FieldPane from './FieldPane'

interface ControlOverviewPaneProps {
  step: PipelineStep
}

export const IndentedText = styled(Text)({
  marginLeft: spacing.X8,
})

export const CampFieldsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.X12,
})

export const ControlOverviewPane: React.FC<ControlOverviewPaneProps> = ({ step }) => {
  switch (step.nextStepsRule?.type) {
    case AttributeManagementNextStepTypeEnum.FieldMatch:
      return <FieldMatchPane step={step} />
    case AttributeManagementNextStepTypeEnum.RegexRules:
      return <FieldPane field={step.nextStepsRule?.campField?.trim() ?? ''} />
    case AttributeManagementNextStepTypeEnum.NumericRange:
      return <FieldPane field={step.nextStepsRule?.valueField?.trim() ?? ''} />
    default:
      return <div />
  }
}
